module.exports = __webpack_public_path__ + "img/IMG-20181201-WA0016.b499f942.jpg";